import { render, staticRenderFns } from "./ProductConfig.vue?vue&type=template&id=72013c41"
import script from "./ProductConfig.vue?vue&type=script&lang=js"
export * from "./ProductConfig.vue?vue&type=script&lang=js"
import style0 from "./ProductConfig.vue?vue&type=style&index=0&id=72013c41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports